import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
  import ConfirmationDialog from "Routes/common/ConfirmationDialog";
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
import moment from 'moment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';

import { 
    fetchORTDrivingReport,
    fetchORTDrivingShotChart,
    deleteORTDrivingTest,
   studentORTDrivingTest,
   fetchORTDrivingTest,
 } from 'Actions';

 import AddItem from '../../../onrangetest/driving/component/addform';
 import EditItem from '../../../onrangetest/driving/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class DrivingChart extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
    };

    
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            club:'',  
            area:'',          
            contact:'',
            shotstring:'',
            loader:false,
            showModal:false, 
            frm:this.props.data.frm, 
            adddiv:false,
            viewdiv:true,
            listdiv:false,
            editdiv:false,
            sepmore:1,
            formValues: [{ club:"", right : "", left : "", fairway : "", area:"", contact:"", missedgreen : "0", process:"0", disright:"", disleft:"", disshort:"", dislong:"", disradio:""}],
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.onEditBack = this.onEditBack.bind(this);
        this.viewList = this.viewList.bind(this);
    }

    handleChange(e, val){

        if(val==1){
            var club=e.target.value;
            var area=this.state.area;
            var contact=this.state.contact;
            this.setState({ club:club });        
        }else if(val==2){
            var area=e.target.value;
            var contact=this.state.contact;
            var club=this.state.club;
            this.setState({ area:area });
        }else if(val==3){
            var contact=e.target.value;
            var club=this.state.club;
            var area=this.state.area;
            this.setState({ contact:contact });
        }
        
        var student=this.state.student;
        if(this.state.startdate==''){
            var stdate=""; 
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==''){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        this.props.fetchORTDrivingReport(student, stdate, eddate, club, area, contact, area).then((data) => {   
           

        }); 
    }

    shotpercentage(section){
        if(section==1){
            var shotstring='AVG DISPERSION';       
        }else if(section==2){
            var shotstring='GOOD CONTACT';
        }else if(section==3){
            var shotstring='BAD CONTACT';
        }else if(section==4){
            var shotstring='LEFT';
        }else if(section==5){
            var shotstring='RIGHT';
        }else if(section==6){
            var shotstring='FAIRWAY';
        }else if(section==7){
            var shotstring='PROCESS';
        }
        this.setState({ shotstring:shotstring});
        var student=this.state.student;
        var contact=this.state.contact;
        var area=this.state.area;
        var club=this.state.club;
        if(this.state.startdate==''){
            var stdate=""; 
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==''){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        
        this.props.fetchORTDrivingShotChart(student, stdate, eddate, club, area, contact, section).then((data) => {   
                        
            this.setState({ showModal:true});

        }); 
    }
    
    addEntry(){
        this.setState({ 
            adddiv:true,
            viewdiv:false,
       });
    }

    viewList(){
        var stdid=this.state.student;
        var start='';
        var end='';
        this.props.studentORTDrivingTest(stdid, start, end).then((data) => {   
            
            this.setState({ 
                viewdiv:false,
                listdiv:true
            });

        });
        
    }

    onBackSection() {
		this.setState({ 
            adddiv:false,
            listdiv:false,
            viewdiv:true,
       });
	}
    
    onEditBack() {
		this.setState({ 
            adddiv:false,
            editdiv:false,
            listdiv:false,
            viewdiv:true,
       });
	}

    editAssessment(assmval){
        
        var id=assmval.grc_userID;
        var date=assmval.grc_date;
          
          this.props.fetchORTDrivingTest(id, date).then((data) => {   
              var resdata=data.data;
              var troptobj=[]; 
              {resdata.map((teamval) => (   
  
                 troptobj.push({
                    club:teamval.grc_clubused,
                    right: teamval.grc_right,
                    left: teamval.grc_left,
                    fairway: teamval.grc_fairway,
                    contact:teamval.grc_contact,
                    area: teamval.grc_area,
                    missedgreen:teamval.grc_outside,
                    process:teamval.grc_process,
                    disright:teamval.grc_right==0 ? 0 : 1, 
                    disleft:teamval.grc_left==0 ? 0 : 1, 
                    disshort:teamval.grc_short==0 ? 0 : 1, 
                    dislong:teamval.grc_long==0 ? 0 : 1, 
                    disradio:teamval.grc_process,  
                 })
              ))} 
              this.setState({ 
                 seldate:resdata[0].grc_date, 
                 student:resdata[0].grc_userID,
                 formValues:troptobj,
                 sepmore:resdata.length
              });
  
              this.setState({ 
                  viewdiv:false,  
                  listdiv:false,              
                  adddiv:false,
                  editdiv:true,
              });
  
          });
      }
  
      deleteForm(assmval){
        this.id = assmval.grc_userID;
        this.date = assmval.grc_date;
        this.confirmationDialog.current.openDialog();
      }
  
     deleteDataPermanent(popupResponse){
        
           if (popupResponse) {
              this.props.deleteORTDrivingTest(this.id, this.date);
              this.data = ""
           }
     }


render() {

    const { ortdrivingchart, ortdrivingshotchart, playerinterventionlist, ortdrivinglist, loading} = this.props; 
    const datacount=ortdrivingchart.length;
    const linedata = ortdrivingshotchart.chartval;
    const linemax = ortdrivingshotchart.highval;
   
    const data1 = [
        
        { x: 'MAJOR LEFT', y: ortdrivingchart.leftmajor, fill:'#ED2939' },
        { x: 'MINOR LEFT', y: ortdrivingchart.leftminor, fill:'#FFF700' },
        { x: 'IN PLAY LEFT', y: ortdrivingchart.leftplay, fill:'#3BB143' },
        { x: 'ON TARGET', y: ortdrivingchart.ontarget, fill:'#0B6623' },
        { x: 'IN PLAY RIGHT', y: ortdrivingchart.rightplay, fill:'#3BB143' },
        { x: 'MINOR RIGHT', y: ortdrivingchart.rightminor, fill:'#FFF700' },
        { x: 'MAJOR RIGHT', y: ortdrivingchart.rightmajor, fill:'#ED2939' },
    ];  
    const data1max=ortdrivingchart.highval;  

    const CustomBarLabel = ({ payload, x, y, value }) => {
        return <text x={x+15} y={y} dy={-8} fill="#757474" textAnchor="middle" >{value}%</text>;
      }

      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
    };

    const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
        
    ];
    const tabledata=ortdrivinglist.map((assmntval,idx) => {     
           const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
           const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
              no:idx+1,
              name: assmntval.student,
              cdate: assmntval.cdate,
              action: ebtn,
              action1:dbtn,
            
            }
    }); 

    return(
        <div>   
                {this.state.viewdiv &&
                <RctCollapsibleCard>
                <div className="row">
                    <div className="col-sm-12 col-lg-3">
                        <h2>ON RANGE DRIVING REPORT</h2>   
                       <div className=""><strong>Total : {ortdrivingchart.totalrow}</strong></div>                     
                    </div>
                    <div className="col-sm-12 col-lg-9">
                        <div className="row">
                            <div className="col-sm-12 col-lg-1">
                                <h5>Club Used</h5>
                            </div>    
                            <div className="col-sm-12 col-lg-3">                        
                            <select  name="club" id="club" className="form-control form-control-alternative" onChange={e => this.handleChange(e,1)} required>
                                <option value="">All</option>
                                <option value="1">Driver</option>
                                <option value="2">3.W</option> 
                                <option value="3">5.W</option> 
                                <option value="4">Hybrid</option>                                          
                            </select>
                            </div> 
                            <div className="col-sm-12 col-lg-1">
                                <h5 style={{marginTop:"10px"}}>Area of Play</h5>
                            </div>    
                            <div className="col-sm-12 col-lg-2">                        
                            <select  name="area" id="area" className="form-control form-control-alternative" onChange={e => this.handleChange(e,2)} required>
                                <option value="">All</option>
                                <option value="1">Fairway</option>
                                <option value="2">Rough</option> 
                                <option value="3">Tee</option>                                              
                            </select>
                            </div>                           
                            <div className="col-sm-12 col-lg-1">
                                <h5 style={{marginTop:"10px"}}>Contact</h5>
                            </div>    
                            <div className="col-sm-12 col-lg-2">                        
                            <select  name="contact" id="contact" className="form-control form-control-alternative" onChange={e => this.handleChange(e,3)} required>
                                <option value="">All</option>
                                <option value="1">Good</option>
                                <option value="2">Bad</option>                                            
                            </select>
                            </div>
                            <div className="col-sm-12 col-lg-2">
                                <div><a onClick={this.addEntry} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.viewList}><span class="icon-list"></span> List</a></div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-sm-12 col-lg-12" style={{marginBottom:"20px"}}></div>
                    {datacount==0?
                     <div className="col-sm-12 col-lg-12">
                      <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                     </div> 
                    :    
                    <>
                    <div className="col-sm-12 col-lg-8">
                        <ResponsiveContainer width={600} height={250} style={{margin:"1px"}}> 
                            <BarChart data={data1}>                               
                                <XAxis dataKey="x" stroke={ChartConfig.axesColor} interval={0} label={{stroke:"black"}} style={{ fontSize: '0.7rem' }}/>
                                <YAxis hide domain={[0, data1max]}  stroke={ChartConfig.axesColor} />
                                <CartesianGrid vertical={false} horizontal={false} stroke={ChartConfig.chartGridColor} />                                
                                <Bar dataKey="y" fill={(data) => data.fill} label={<CustomBarLabel />} barSize={30}/> 
                            </BarChart>
                        </ResponsiveContainer>                            
                    </div>
                    <div className="col-sm-12 col-lg-4">
                        <List className="p-0">
                            <ListItem>
                                <ListItemText primary="TOTAl SHOTS" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.totalshot}</strong> </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(1)}>
                                <ListItemText primary="AVG DISPERSION" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.avgdisp+' YDS'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(2)}>
                                <ListItemText primary="GOOD CONTACT" />
                                <ListItemSecondaryAction><strong>{ortdrivingchart.good+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(3)}>
                                <ListItemText primary="BAD CONTACT" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.bad+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(4)}>
                                <ListItemText primary="LEFT" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.avgleft+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(5)}>
                                <ListItemText primary="RIGHT" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.avgright+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(6)}>
                                <ListItemText primary="FAIRWAY" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.avgfairway+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(7)}>
                                <ListItemText primary="PROCESS" /> 
                                <ListItemSecondaryAction><strong>{ortdrivingchart.process+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                        </List>
                    </div>
                      
                    </>
                    }          
                </div>

                </RctCollapsibleCard>
                }
                {this.state.showModal && (
                    <Dialog open={this.state.showModal} onClose={() => this.setState({ showModal: false })} PaperProps={{ style: { width: 576 } }}>
                        <DialogTitle>
                            <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>{this.state.shotstring}</span>
                                <CloseIcon onClick={() => this.setState({ showModal: false })} style={{ cursor: 'pointer' }} />
                            </div>
                        </DialogTitle>
                        <DialogContent >
                            <ResponsiveContainer width='100%' height={300}>
                                <LineChart data={linedata}>
                                    <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                                    <YAxis stroke={ChartConfig.axesColor} domain={[0, linemax]}/>
                                    <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                                    <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />
                                                                    
                                    <Line type="bumpX" dataKey="y" stroke={ChartConfig.color.info} label={{ fill: '#757474', fontSize: 15, position:'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </DialogContent>
                        
                    </Dialog>
                )}

                {this.state.adddiv&&
                 <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.listdiv &&
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="ON RANGE DRIVING LIST" fullBlock>
                            <MUIDataTable    
                                    title={<div><Button onClick={ ()=>this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}                               
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                            />   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editdiv && 
                  <EditItem onClick={this.onEditBack} data={this.state}/>              
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'driving test'}
                />

                
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ ortdriving, playerintervention}) => {
    const { ortdrivingchart,  ortdrivingshotchart, ortdrivinglist, loading } = ortdriving;
    const { playerinterventionlist } = playerintervention;
    return { ortdrivingchart, playerinterventionlist, ortdrivingshotchart, ortdrivinglist, loading };
   
}


export default connect(mapStateToProps, {
    fetchORTDrivingReport,
    fetchORTDrivingShotChart,
    deleteORTDrivingTest,
   studentORTDrivingTest,
   fetchORTDrivingTest,
})(DrivingChart);
